export enum RMHttpStatusCode {
  Unauthorized = 401,
  BadRequest = 400,
  Forbidden = 403,
  FeatureSelection = 452,
  InternalServerError = 500,
  Timeout = 504,
}
